import errorCodes from '../../api/errorCodes';

const formatNotification = n => {
  if (typeof n.message === 'object') {
    if (!n.title && n.type === 'error') n.title = 'Ошибка';
    let { status, errors = {} } = n.message;
    if (Array.isArray(errors) && errors.length) {
      errors = errors[0];
    }
    const { code, detail } = errors;
    if (status && code) {
      n.message = errorCodes[code] || detail || '';
      if (process.env.NODE_MODE === 'local') {
        n.title += ` (${status})`;
        n.message += ` (${code})`;
      }
    }
  }
  if (!n.color) {
    switch (n.type) {
      case 'success':
        n.color = '#95D4E9';
        break;
      case 'warning':
        n.color = '#FFB71B';
        break;
      default:
        n.color = '#f34744';
    }
  }
  return n;
}

export default {
  namespaced: true,

  state: () => ({
    items: [],
  }),

  getters: {
    list: state => state.items,
  },

  mutations: {
    add: (state, notification) => state.items.push(notification),
    remove: (state, id) => state.items = state.items.filter(i => i.id != id),
  },

  actions: {
    create({ state, commit }, {
      id = Math.random().toString(36).substr(2, 9),
      title = '',
      message = '',
      type = 'error',
      color = '',
      lifetime = 5,
      closable = true,
    }) {
      if (state.items.findIndex((n) => n.id === id) !== -1) return; // дублирование id
      commit('add', formatNotification({
        id, title, message, type, color, lifetime, closable,
      }));
      if (lifetime) {
        setTimeout(() => {
          commit('remove', id);
        }, lifetime * 1000);
      }
    },
    remove({ commit }, id) {
      commit('remove', id);
    },
  },
}
